<template>
  <v-card>
    <v-card-title>{{ sourceStat.source }}</v-card-title>
    <v-card-subtitle>{{ currentItem.datetime }}</v-card-subtitle>
    <div style="padding: 24px;">
      <v-row no-gutters>
        <v-col>
          <v-row dense>
            <v-col>Paid clicks: {{ sourceStat.clicks_count }} </v-col>
          </v-row>
          <v-row dense v-if="showUsers">
            <v-col> Users: {{ sourceStat.users_count }} </v-col>
          </v-row>
          <v-row dense>
            <v-col> Sessions: {{ sourceStat.sessions_count }} </v-col>
          </v-row>
          <v-row dense>
            <v-col> Orders: {{ sourceStat.orders_count }} </v-col>
          </v-row>
        </v-col>
        <v-col>
          <div v-if="sourceStat.ban_reason && sourceStat.ban_reason.length > 0">
            <v-row dense v-for="reason in sourceStat.ban_reason" :key="reason">
              <v-col> Ban reason: {{ reason }} </v-col>
            </v-row>
          </div>
          <div v-else>
            No ban reasons
          </div>
        </v-col>
      </v-row>
      <SessionDetailsTable :source-stat="sourceStat" v-if="showTable" />
    </div>
  </v-card>
</template>

<script>
import SessionDetailsTable from "@/components/_Tables/SessionDetailsTable";

export default {
  name: "SessionDetailsCard",
  components: { SessionDetailsTable },
  props: {
    sourceStat: {
      type: Object,
      required: true
    },
    currentItem: {
      type: Object,
      required: true
    },
    showTable: {
      type: Boolean,
      default: true
    },
    showUsers: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped></style>
